<!-- Общий набор компактных карточек с ключевыми показателями. -->
<template>
  <section class="base-metrics" :aria-label="ariaLabel">
    <article
      v-for="metric in metrics"
      :key="metric.key"
      class="base-metric"
    >
      <div class="base-metric__header">
        <AppIcon v-if="metric.icon" :name="metric.icon" :size="14" />
        <span>{{ metric.label }}</span>
      </div>
      <div class="base-metric__body">
        <strong class="base-metric__value">{{ metric.value }}</strong>
        <span v-if="metric.detail" class="base-metric__detail">
          {{ metric.detail }}
        </span>
      </div>
    </article>
  </section>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseMetricsBlocks",

  components: {
    AppIcon,
  },

  props: {
    ariaLabel: {
      type: String,
      default: "Сводка",
    },
    metrics: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.base-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.base-metric {
  display: grid;
  gap: 8px;
  min-height: 68px;
  padding: 11px 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.base-metric__header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.base-metric__header :deep(svg) {
  display: block;
  flex-shrink: 0;
}

.base-metric__body {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.base-metric__detail {
  display: block;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.35;
}

.base-metric__value {
  display: block;
  overflow: hidden;
  color: #111827;
  font-size: 19px;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1260px) {
  .base-metrics {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }
}

@media (max-width: 760px) {
  .base-metrics {
    grid-template-columns: 1fr;
  }
}
</style>
